import { render, staticRenderFns } from "./videoDiadog.vue?vue&type=template&id=d52072e8&scoped=true&"
import script from "./videoDiadog.vue?vue&type=script&lang=js&"
export * from "./videoDiadog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52072e8",
  null
  
)

export default component.exports